
















import { Component, Mixins, Prop } from "vue-property-decorator";
import { IHisInformationAccessible } from "../../../../domain/his";
import { RightSidePane as Container } from "../../../panes";
import { IRestrictions } from "../EditingDocument";
import {
  EditMenuContainer,
  DocumentEditorMenu,
  ReferenceFileMenu,
  DocumentExternalMenu,
  IDocumentEditMenuConfiguration,
} from "../contents";
import { PaneMixin } from "./mixins";

@Component({
  components: {
    Container,
    EditMenuContainer,
    DocumentEditorMenu,
    ReferenceFileMenu,
    DocumentExternalMenu,
  }
})
export default class RightSidePane extends Mixins(PaneMixin) {
  @Prop()
  restrictions: IRestrictions;

  @Prop()
  editMenuConfiguration: IDocumentEditMenuConfiguration;

  @Prop()
  hisInformationAccessor: IHisInformationAccessible;
}
